import { UserEditMode } from "@/Administration/Models/UI/Users/UserEditMode";
import { ClickableTextItem } from "@/Common/Api/ClickableText/Dto/ClickableTextItem";
import { Employee } from "@/Common/Api/Employee/Dto/Employee";
import { LicenseDto } from "@/Common/Api/Labs/Dto/Responses/LicenseDto";
import { EmployeeType } from "@/Common/Models/Employee/Enums/EmployeeType";
import * as ServerOperations from "@/Common/Operations/operations.server";
import * as SubServerOperations from "@/Common/Operations/operations.server.sub";
import { BaseAction } from "@/Common/Stores/Actions/BaseAction";

class AdministrationUsersAction extends BaseAction {
    public getSearchAllEmployee(): void {
        this.Execute(ServerOperations.Server.GetSearchableEmployees);
    }

    public changeActivationUsers(contactId: string, isInActive: boolean): void {
        var requestData = {
            EmployeeContactId: contactId,
            IsInactive: isInActive
        };

        this.Execute(ServerOperations.Server.UpdateActivateEmployee, requestData);
    }

    public getEmployeeInfo(employeeId: string, includeInactiveServices?: boolean): void {
        var requestData = {
            EmployeeId: employeeId,
            IncludeInactiveServices: includeInactiveServices
        };
        this.Execute(ServerOperations.Server.GetEmployeeInfo, requestData);
    }

    public saveProfilePic(path: string, employeeContactId: string): void {
        let requestData = {
            ContactId: employeeContactId,
            ImagePath: path
        };

        this.Execute(ServerOperations.Server.Myle_SaveProfileImage, requestData, SubServerOperations.Administration.SaveProfileImage);
    }

    public getOrphanLabs(licences: LicenseDto[]): void {
        let requestData = {
            LicenseNumbers: licences
        };

        this.Execute(ServerOperations.Server.ARLMYLE_GetOrphanLabForwards, requestData);
    }

    public upsertEmployee(employee: Employee, editMode: UserEditMode, onError?: () => void): void {
        var requestData = {
            Employee: employee
        };

        if (editMode == UserEditMode.Create)
            this.dispatch(ServerOperations.Server.Myle_Admin_CreateEmployee, requestData, onError);
        else if (editMode == UserEditMode.Edit) {
            // this.Execute(ServerOperations.Server.Myle_Admin_UpdateDemographic, requestData);
            // this.Execute(ServerOperations.Server.Myle_Admin_UpdatePractice, requestData);
            // this.Execute(ServerOperations.Server.Myle_Admin_UpdateConfiguration, requestData);
            // this.Execute(ServerOperations.Server.Myle_Admin_UpdateTools, requestData);
            this.Execute(ServerOperations.Server.Myle_Admin_UpdateUser, requestData);
        }
    }

    public saveOrphanLabsClinician(id: string, siteContext: string, dateFrom?: Date, dateTo?: Date, userId?: string, then?: (isSuccess: boolean) => void): void {
        var request = {
            Id: id,
            From: dateFrom,
            To: dateTo,
            SiteContext: siteContext,
            UserId: userId
        };

        if (dateFrom == null) { delete request.From; }
        if (dateTo == null) { delete request.To; }

        this.dispatch(ServerOperations.Server.ARLMYLE_SaveOrphanLabForwards, request, then);
    }

    public removeOrphanLabClinician(id: string): void {
        this.Execute(ServerOperations.Server.ARLMYLE_RemoveClinicianFromOrphanLabForwards, { Id: id });
    }

    public updatePdfTagsForEmployee(tags: string[], employeeId: string): void {
        var requestData = {
            EmployeeId: employeeId,
            Tags: tags
        };
        this.Execute(ServerOperations.Server.Configuration_UpdateEmployeePdfTags, requestData);
    }

    public updateUserType(id: string, type: number, contactId: string, licenseOrganizationRuleId: string, licenseOrganizationSpecializationId: string): void {
        var request = {
            EmployeeId: id,
            Type: type,
            ContactId: contactId,
            LicenseOrganizationRuleId: licenseOrganizationRuleId,
            LicenseOrganizationSpecializationId: licenseOrganizationSpecializationId
        };
        this.Execute(ServerOperations.Server.UpdateEmployeeType, request);
    }

    public getCliackableTextSpecificUser(id: string, isImportDeleteTexts?: boolean, userType?: EmployeeType): void {
        var request = {
            EmployeeId: id,
            IsImportDeleteTexts: isImportDeleteTexts,
            Type: userType
        };
        this.Execute(ServerOperations.Server.GetClickableTextSpecificUser, request);
    }

    public createListOfClickableText(textList: ClickableTextItem[], emoloyeeId: string, isCreateUser?: boolean): void {
        var request = {
            TextList: textList,
            EmployeeId: emoloyeeId,
            IsCreateUser: isCreateUser
        };
        this.Execute(ServerOperations.Server.Create_List_ClickableText, request);
    }

    public reloadEmployees(): void {
        cacheStore.actions.refreshServices();
    }

    public deleteProfilePicEmployee(id: string): void {
        var request = {
            ProfilePicId: id

        };
        this.Execute(ServerOperations.Server.DeleteProfilePicEmployee, request);
    }

    public deleteClickableTextSection(employeeId: string, context: string, lang: string): void {
        var request = {
            EmployeeId: employeeId,
            Context: context,
            LanguageCode: lang
        };
        this.Execute(ServerOperations.Server.Employee_DeleteClickableTextSection, request);
    }

    public updateConfigurationEmployee(employee: Employee): void {
        var requestData = {
            Employee: employee
        };
        this.Execute(ServerOperations.Server.Myle_Admin_UpdateConfiguration, requestData);
    }

    public getAllClickableTextCategories(context: string, lang: string): void {
        var request = {
            Context: context,
            LanguageCode: lang

        };
        this.Execute(ServerOperations.Server.Employee_GetClickableTextCategories, request);
    }

    public getClickableTextDetails(tab: string, context: string, lang: string): void {
        var request = {
            TabName: tab,
            Context: context,
            LanguageCode: lang
        };
        this.Execute(ServerOperations.Server.Employee_getClickableTextDetails, request);
    }

    public importListOfClickableText(textList: ClickableTextItem[], emoloyeeId: string, context: string, tabs: string[], lang: string): void {
        var request = {
            TextList: textList,
            EmployeeId: emoloyeeId,
            Context: context,
            TabsName: tabs,
            LanguageCode: lang
        };
        this.Execute(ServerOperations.Server.Import_ClickableText_List, request);
    }

    public getAllUsersWithClickableText(context: string, lang: string): void {
        var request = {
            Context: context,
            LanguageCode: lang

        };
        this.Execute(ServerOperations.Server.LoadAllUsersWithClickableText, request);
    }

    public getTabDetailsFromSpecificUser(context: string, employeeId: string, lang: string): void {
        var request = {
            Context: context,
            LanguageCode: lang,
            EmployeeId: employeeId
        };
        this.Execute(ServerOperations.Server.GetClickableTextDetailsSpecificUserSpecificTab, request);
    }

    public GetGroupInfo(groupId: string): void {
        var requestData = {
            EmployeeGroupId: groupId
        };
        this.Execute(ServerOperations.Server.Myle_Admin_LoadGroupSetting, requestData);
    }

    public resendEmailVerificationCode(emailAddress: string, contactPointId: string, contactId: string, contactFacetId: string, language: string): void {
        var requestData = {
            Address: emailAddress,
            ContactPointId: contactPointId,
            ContactId: contactId,
            ContactFacetId: contactFacetId,
            Language: language
        };

        this.Execute(ServerOperations.Server.Myle_Employee_Resend_Verification_Code, requestData);
    }
}

export { AdministrationUsersAction };
